import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../Assets/Images/landing/eww-logo.png";
import "../../Assets/Styles/pages/footer.scss";

const socials = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/ezywatermark/",
    d: "M13.5 22v-8h2.7l.4-3.2h-3.1V8.7c0-.9.3-1.6 1.7-1.6h1.6V4.2C16.5 4.1 15.4 4 14.3 4c-2.4 0-4 1.5-4 4.2v2.6H7.6V14h2.7v8h3.2Z",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/ezy_watermark/?igshid=152p322uqciym",
    d: "M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.42.56.22.96.48 1.38.9.42.42.68.82.9 1.38.17.42.37 1.06.42 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.42 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.17-1.06.37-2.23.42-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.42-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.17-.42-.37-1.06-.42-2.23C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.42-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.17 1.06-.37 2.23-.42C8.42 2.21 8.8 2.2 12 2.2Zm0 5.6a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4Zm5.4-.6a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM12 9.8a2.2 2.2 0 1 1 0 4.4 2.2 2.2 0 0 1 0-4.4Z",
  },
];

const Footer: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const history = useHistory();

  const handlePage = (page: string) => {
    history.push(page);
  };

  if (location.pathname === "/edit") {
    return null;
  }

  const year = new Date().getFullYear();

  return (
    <footer className="lr-footer">
      <div className="lr-footer__inner">
        <div className="lr-footer__top">
          <a
            href="/"
            className="lr-footer__brand"
            onClick={(e) => {
              e.preventDefault();
              handlePage("/");
            }}
          >
            <img src={logo} alt={String(t("lang.ezywatermark"))} />
            <span>{t("lang.ezywatermark")}</span>
          </a>

          <nav className="lr-footer__links">
            <button type="button" onClick={() => handlePage("/features")}>
              {t("Features")}
            </button>
            <button type="button" onClick={() => handlePage("/pricing")}>
              {t("Pricing")}
            </button>
            <button type="button" onClick={() => handlePage("/faq")}>
              FAQs
            </button>
            <button type="button" onClick={() => handlePage("/blogs")}>
              {t("Blogs")}
            </button>
          </nav>

          <div className="lr-footer__socials">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d={s.d} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        <div className="lr-footer__bottom">
          <p>
            © {year} {t("lang.ezywatermark")}
          </p>
          <a className="lr-footer__email" href={`mailto:${t("Footer.Email")}`}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M4 6h16v12H4z" />
              <path d="m4 7 8 6 8-6" />
            </svg>
            {t("Footer.Email")}
          </a>
          <div className="lr-footer__legal">
            <span onClick={() => handlePage("/privacy-policy")}>{t("FooterText2")}</span>
            <span onClick={() => handlePage("/terms")}>{t("FooterText3")}</span>
            <span onClick={() => handlePage("/refund-policy")}>{t("FooterText4")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
